import { lazy, Suspense } from "react";
import { DashboardLayout } from "components/dashboard/DashboardLayout";
import BaseLayout from "components/BaseLayout";
// import { Dashboard } from "pages/dashboard";
import { Navigate, useRoutes } from "react-router-dom";
import { Loading } from "components/shared/Loading";
import RootLayout from "components/RootLayout";
import SignUp from "pages/signup";
import SignIn from "pages/signin";
import ResetPassword from "pages/reset-password";
import NewPassword from "pages/new-password";
import Confirmation from "pages/signup/Confirmation";

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return (
    <Suspense fallback={<Loading />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Routes() {
  const dashboardRoutes = [
    {
      path: "",
      // element: <Dashboard />,
      element: <Navigate to="merchants" />,
    },

    /* PLOP_ROUTE_PAGE_APPLY */
    {
      path: "operating-wallet/ow-management",
      element: <OperationWalletManagement />,
    },
    {
      path: "operating-wallet-history-log/operatingactions",
      element: <Operatingwalletlog />,
    },
    {
      path: "operating-wallet-history-log/tokentransactions",
      element: <TokenTranssactions />,
    },
    {
      path: "operating-wallet-history-log/history-log",
      element: <OWHistoryLog />,
    },
    {
      path: "whitelist-email",
      element: <Whitelist />,
    },
    {
      path: "system-withdraw-history",
      element: <SystemWithdrawHistoryLog />,
    },
    {
      path: "admin-management",
      element: <AdminManagement />,
    },
    {
      path: "system-balances",
      element: <SystemBalances />,
    },
    {
      path: "settings/service-fee",
      element: <Setting />,
    },
    {
      path: "unmatched-payment",
      element: <UnmatchedPayment />,
    },
    {
      path: "widthdrawal-history",
      element: <WithdrawalHistory />,
    },
    {
      path: "charges",
      element: <Charges />,
    },
    {
      path: "payments",
      element: <Payments />,
    },
    {
      path: "settings/crypto-currencies",
      element: <CryptoCurrency />,
    },
    {
      path: "register-email",
      element: <RegisterEmail />,
    },
    {
      path: "merchants",
      children: [
        {
          path: "",
          element: <Merchants />,
        },
        {
          path: ":id",
          element: <MerchantDetail />,
        },
      ],
    },

    {
      path: "settings/chains",
      element: <Chains />,
    },
  ];

  return useRoutes([
    {
      path: "dashboard",
      element: <DashboardLayout />,
      children: dashboardRoutes,
    },
    {
      path: "commerce",
      element: <CommerceLayout />,
      children: [
        {
          path: "invoices/:id",
          element: <InvoicesCommerce />,
        },
        {
          path: "charges/:id",
          element: <ChargesCommerce />,
        },
      ],
    },
    {
      path: "*",
      element: <BaseLayout />,
      children: [
        { path: "404", element: <Page404 /> },
        { path: "*", element: <Navigate to="/404" replace /> },
      ],
    },
    {
      path: "/",
      element: <RootLayout />,
      children: [
        {
          path: "",
          element: <Navigate to="/dashboard" replace />,
        },
        {
          path: "signup",
          element: <SignUp />,
        },
        {
          path: "signin",
          element: <SignIn />,
        },
        {
          path: "reset-password",
          element: <ResetPassword />,
        },
        {
          path: "new-password",
          element: <NewPassword />,
        },
        {
          path: "confirmation",
          element: <Confirmation />,
        },
        {
          path: "active-account",
          element: <ActiveAccount />,
        },
      ],
    },
    // { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}

// const SignUp = Loadable(lazy(() => import("pages/signup")));
// const SignIn = Loadable(lazy(() => import("pages/signin")));
// const ResetPassword = Loadable(lazy(() => import("pages/reset-password")));
// const NewPassword = Loadable(lazy(() => import("pages/new-password")));
// const Confirmation = Loadable(lazy(() => import("pages/signup/Confirmation")));
const ActiveAccount = Loadable(lazy(() => import("pages/signin/ActiveAccount")));
const InvoicesCommerce = Loadable(lazy(() => import("pages/commerce/invoices")));
const ChargesCommerce = Loadable(lazy(() => import("pages/commerce/charges")));
const CommerceLayout = Loadable(lazy(() => import("components/commerce/CommerceLayout")));
/* PLOP_COMPONENTS_PAGE_LAZY_IMPORT */
const OperationWalletManagement = Loadable(
  lazy(() => import("pages/dashboard/operationwalletmanagement")),
);
const Operatingwalletlog = Loadable(
  lazy(() => import("pages/dashboard/operatingwalletlog/operatingActions")),
);
const TokenTranssactions = Loadable(
  lazy(() => import("pages/dashboard/operatingwalletlog/tokenTranssactions")),
);
const OWHistoryLog = Loadable(
  lazy(() => import("pages/dashboard/operatingwalletlog/OperatingWalletHistoryLog")),
);
const Whitelist = Loadable(lazy(() => import("pages/dashboard/whitelist")));
const SystemWithdrawHistoryLog = Loadable(
  lazy(() => import("pages/dashboard/systemwithdrawhistorylog")),
);
const AdminManagement = Loadable(lazy(() => import("pages/dashboard/adminmanagement")));
const SystemBalances = Loadable(lazy(() => import("pages/dashboard/systembalances")));
const Setting = Loadable(lazy(() => import("pages/dashboard/setting")));
const UnmatchedPayment = Loadable(lazy(() => import("pages/dashboard/unmatchedpayment")));
const WithdrawalHistory = Loadable(lazy(() => import("pages/dashboard/withdrawalhistory")));
const Charges = Loadable(lazy(() => import("pages/dashboard/charges")));
const Payments = Loadable(lazy(() => import("pages/dashboard/payments")));
const CryptoCurrency = Loadable(lazy(() => import("pages/dashboard/cryptocurrency")));
const RegisterEmail = Loadable(lazy(() => import("pages/dashboard/registeremail")));
const Merchants = Loadable(lazy(() => import("pages/dashboard/merchants")));
const MerchantDetail = Loadable(lazy(() => import("pages/dashboard/merchants/id")));
const Chains = Loadable(lazy(() => import("pages/dashboard/Chains")));
const Page404 = Loadable(lazy(() => import("pages/Page404")));
